import { ImageCheck, LinkWrapper } from "Explore/Components";
import styles from "./HomeFacultyCard.module.scss";
import { ImageCheckType } from "Explore/Config/ImageType";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";

const HomeFacultyCard = ({ data }) => {
  const statistics = [
    {
      icon: IconPack.publications,
      value: data.publication_count,
      title: "publications",
    },
    { icon: IconPack.h_index, value: data.h_index, title: "h-index" },
    { icon: IconPack.citation, value: data.citation_count, title: "citations" },
  ];
  return (
    <LinkWrapper
      className={styles["home-faculty-card__wrapper"]}
      link={`/explore/faculty/${data.explore_slug || data.id}`}
      component={
        <div className={styles["home-faculty-card"]}>
          <div className={styles["home-faculty-card__left"]}>
            <ImageCheck
              url={data.photo}
              alt={data.name}
              type={ImageCheckType.FACULTY_AVATAR}
              className={styles["home-faculty-card__left--avatar"]}
            />
          </div>
          <div className={styles["home-faculty-card__right"]}>
            <div className={styles["home-faculty-card__right--info"]}>
              <div className={styles["home-faculty-card__right--info--title"]}>
                <p
                  className={
                    styles["home-faculty-card__right--info--title--name"]
                  }
                >
                  {data.name}
                </p>
                <p
                  className={
                    styles["home-faculty-card__right--info--title--institution"]
                  }
                >
                  {data.institution.name}
                </p>
              </div>
              <div className={styles["home-faculty-card__right--info--stat"]}>
                <p
                  className={
                    styles["home-faculty-card__right--info--stat--position"]
                  }
                >
                  {data.position}
                </p>
                <div
                  className={
                    styles["home-faculty-card__right--info--stat--statistics"]
                  }
                >
                  {statistics.map(({ icon, value, title }, index) => {
                    return (
                      <div
                        key={index}
                        className={
                          styles[
                            "home-faculty-card__right--info--stat--statistics--item"
                          ]
                        }
                      >
                        {icon}
                        <p>
                          <span>{numberRegex(value)}</span>
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={styles["home-faculty-card__right--keywords"]}>
              <div
                className={
                  styles["home-faculty-card__right--keywords__wrapper"]
                }
              >
                {(data.keywords || []).slice(0, 2).map((e, i) => (
                  <div
                    className={
                      styles["home-faculty-card__right--keywords--item"]
                    }
                    key={i}
                  >
                    <p>{e.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default HomeFacultyCard;
